module.exports = __webpack_public_path__ + "img/ic_icon_cvu_transfer.8c26e1a4.png";